import { COUNTDOWN_NODE_NAME } from '@builder4/shared/utils/constants';
import { MigratableJson } from '../MigratableJson';

const DEFAULT_MIN_HEIGHT = 64;

/**
 * Migration v17: Backfill missing minHeight on Countdown nodes
 *
 * The CountdownPropsDto (ENG-18565) enforces minHeight as a required field (@IsDefined).
 * AI-generated pages may produce Countdown nodes without this property, causing CraftJSON
 * validation to fail. This migration adds the default value of 64 to any Countdown node
 * that does not already have minHeight defined.
 */
export default function toV17<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    if (node.displayName !== COUNTDOWN_NODE_NAME) continue;

    const props = node.props;
    if (!props || typeof props !== 'object') continue;

    const propsCast = props as Record<string, unknown>;
    if (typeof propsCast.minHeight === 'undefined') {
      node.props = { ...propsCast, minHeight: DEFAULT_MIN_HEIGHT };
    }
  }

  return data;
}
